import React from "react";
import { Box, Card, Skeleton } from "@mui/material";

import CustomButton from "../CustomButton";

const UserLoadingCard = () => {
  return (
    <Card
      sx={{
        width: "100%",
        padding: `16px`,
        border: `2px solid`,
        borderColor: "black.main",
        borderRadius: `16px`,
        maxHeight: "80px",
        boxShadow: `0px 0px 0px`,
        marginBottom: `16px`,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Skeleton
          sx={{ mr: "8px" }}
          variant='circular'
          width={48}
          height={48}
        />

        <Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Skeleton width={90} />
          </Box>

          <Skeleton width={70} height={15} />
        </Box>
      </Box>
      <CustomButton
        className='u-follow'
        title={"Follow"}
        fSize='12px'
        width='61px'
        height='32px'
        bShadow='2px'
        bgColor='primary.main'
      />
    </Card>
  );
};

export default UserLoadingCard;
